import React, { FC, useCallback } from "react";
import { useAuthentication } from "@welldigital/ui-common/Authentication/components/AuthenticationProvider";
import { AUTHENTICATED_STATE } from "@welldigital/ui-common/Authentication/components/consts";
import { CircularProgress, Box } from "@material-ui/core";
import { Route, RouteProps } from "react-router-dom";

export type PrivateRouteProps = Omit<RouteProps, "component"> & {
  component: React.ComponentType;
  shouldTriggerAuthentication: boolean;
};

const PrivateRoute: FC<PrivateRouteProps> = ({
  component: Component,
  shouldTriggerAuthentication,
  ...rest
}): JSX.Element | null => {
  const { authenticatedState, performAuthentication } = useAuthentication();

  if (
    shouldTriggerAuthentication &&
    authenticatedState === AUTHENTICATED_STATE.UNKNOWN
  ) {
    setTimeout(() => {
      performAuthentication(true);
    }, 0);
  }
  const renderer = useCallback(
    (props) => {
      return <Component {...rest} {...props} />;
    },
    [rest]
  );

  return authenticatedState === AUTHENTICATED_STATE.UNKNOWN ? (
    <Box display={"flex"} justifyContent={"center"} p={4}>
      <CircularProgress />
    </Box>
  ) : authenticatedState === AUTHENTICATED_STATE.NO ? null : (
    <Route {...rest} render={renderer} />
  );
};

export default PrivateRoute;
